export const queryPage = '/icps/system/sign/dataCollection/engineeringManagement/QueryPage'
import request from '@/utils/request'
/**获取工程维护*/
export function queryMaintenance(data) {
  return request({
    url: '/icps/system/sign/dataCollection/control/queryMaintenance',
    method: 'post',
    data
  })
}
/**保存工程维护*/
export function saveMaintenance(data) {
  return request({
    url: '/icps/system/sign/dataCollection/control/saveMaintenance',
    method: 'post',
    data
  })
}
/**修改工程调控*/
export function saveControl(data) {
  return request({
    url: '/icps/system/sign/dataCollection/control/saveControl',
    method: 'post',
    data
  })
}
/**查询工程调控*/
export function queryControl(data) {
  return request({
    // url: '/icps/system/sign/dataCollection/control/queryControl',原接口
    url: '/icps/system/sign/dataCollection/control/queryControlNew',
    method: 'post',
    data
  })
}
/**保存或修改信息调价*/
export function savePhase(data) {
  return request({
    url: '/icps/system/sign/dataCollection/control/savePhase',
    method: 'post',
    data
  })
}
/**获取工程调价*/
export function queryPrising(data) {
  return request({
    url: '/icps/system/sign/dataCollection/control/queryPrising',
    method: 'post',
    data
  })
}
/**保存或修改信息调价*/
export function savePrising(data) {
  return request({
    url: '/icps/system/sign/dataCollection/control/savePrising',
    method: 'post',
    data
  })
}
/**获取合同价格*/
export function getDisClostDisAddCost(data) {
  return request({
    url: '/icps/system/sign/dataCollection/productCost/getDisClostDisAddCost',
    method: 'post',
    data
  })
}
/**修改合同价格*/
export function saveOrUpdateDisAddCost(data) {
  return request({
    url: '/icps/system/sign/dataCollection/productCost/saveOrUpdateDisAddCost',
    method: 'post',
    data
  })
}
/**查询调价*/
export function getRevisePriceProduction(data) {
  return request({
    url: '/icps/system/sign/dataCollection/disclose/getRevisePriceProduction',
    method: 'post',
    data
  })
}
/**添加调价*/
export function updateRevisePrice(data) {
  return request({
    url: '/icps/system/sign/dataCollection/disclose/updateRevisePrice',
    method: 'post',
    data
  })
}
/**删除调价*/
export function deleteRevisePrice(data) {
  return request({
    url: '/icps/system/sign/dataCollection/disclose/deleteRevisePrice',
    method: 'post',
    data
  })
}
// 获取调价记录
export function getRevisePrice(params) {
  return request({
    url: "/icps/system/sign/dataCollection/disclose/getRevisePrice",
    method: "post",
    data: params,
  });
}
// 删除信息价强度等级
export function updatePrising(params) {
  return request({
    url: "/icps/system/sign/dataCollection/control/updatePrising",
    method: "get",
    params,
  });
}

// 设置产品价格
export function saveReadjustPricesResord(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/saveReadjustPricesResord",
    method: "post",
    data: params,
  });
}

// 获取生效记录
export function queryResordPage(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/queryResordPage",
    method: "post",
    data: params,
  });
}

// 删除生效记录
export function delReadjustPricesResord(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/delReadjustPricesResord",
    method:"get",
    params
  });
}

// 获取交底信息
export function queryDisclose(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/queryDisclose",
    method:"get",
    params
  });
}

// 获取交底信息
export function queryReadjustCostDetail(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/queryReadjustCostDetail",
    method: "post",
    data: params,
  });
}


// 信息调价-获取界面数据
export function queryInfoReadjustCostDetail(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/queryReadjustCostDetail",
    method: "post",
    data: params,
  });
}



// 获取调价记录
export function queryGradeAjustResord(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/queryGradeAjustResord",
    method:"get",
    params
  });
}

// 信息调价-保存
export function saveOrUpdateInfoConsultPrice(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/saveOrUpdateConsultPrice",
    method: "post",
    data: params,
  });
}


// 保存产品调价
export function saveOrUpdateConsultPrice(data) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/saveOrUpdateConsultPrice",
    method:"post",
    data
  });
}
// 产品调价-调价规则基准价获取期数
export function queryPeriodsByCity(params) {
  return request({
    url: "/icps/system/sign/basics/information/price/queryPeriodsByCity",
    method:"get",
    params
  });
}
// 产品调价-调价规则基准价获取标号和区域
export function queryAreaByPeriods(params) {
  return request({
    url: "/icps/system/sign/basics/information/price/queryAreaByPeriods",
    method:"get",
    params
  });
}
// 产品调价-调价规则信息价获取标号
export function queryGradeList(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/queryGradeList",
    method:"post",
    data
  });
}
export function queryPatternList(data) {
  return request({
    url: "/icps/system/sign/basics/information/price/queryPatternList",
    method:"post",
    data
  });
}

// 保存特殊条款
export function updateMixRatio(data) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/updateMixRatio",
    method:"post",
    data
  });
}


// 保存产品调价设置
export function saveOrUpdatePriceRule(data) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/saveOrUpdatePriceRule",
    method:"post",
    data
  });
}


// 保存小方量运输费用
export function saveSmallVolumeTransportation(data) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/saveSmallVolumeTransportation",
    method:"post",
    data
  });
}

// 获取小方量运输费用
export function querySmallVolumeTransportation(data) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/querySmallVolumeTransportation",
    method:"post",
    data
  });
}


//获取产品调价设置
export function queryPriceRule(params) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/queryPriceRule",
    method:"get",
    params
  });
}
//获取泵机类型
export function queryPumpList(params) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/queryPumpList",
    method:"get",
    params
  });
}
//获取泵送费用数据
export function queryPumpCost(params) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/queryPumpCost",
    method:"get",
    params
  });
}
//保存泵送费用数据
export function savePumpCost(data) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/savePumpCost",
    method:"post",
    data
  });
}
//保存泵送费调价
export function savePsavePumpCostAdjustumpCost(data) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/savePumpCostAdjust",
    method:"post",
    data
  });
}
//删除泵送费调价
export function delPumpCostAdjust(params) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/delPumpCostAdjust",
    method:"get",
    params
  });
}
//获取泵送费调价记录 
export function queryPumpCostAdjust(params) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/queryPumpCostAdjust",
    method:"get",
    params
  });
}
//获取价格复用列表
export function queryResordlist(data) {
  return request({
    url: "/icps/system/sign/dataCollection/productCost/queryResordlist",
    method:"post",
    data
  });
}
//保存运输价区间
export function saveContractTransportationDetail(data) {
  return request({
    url: "/icps/system/sign/dataCollection/pumpingCosts/saveContractTransportationDetail",
    method:"post",
    data
  });
}

